export default __webpack_public_path__ + "static/media/pro-elevate-dmb-1.211c3bc6.png";